import { Component, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DataService } from 'src/app/services/data.service';
import { debugForm, setRequired } from 'src/app/shared/utils';

@Component({
  selector: 'app-pagamento-fatturazione',
  templateUrl: './pagamento-fatturazione.component.html',
  styleUrls: ['./pagamento-fatturazione.component.scss']
})
export class PagamentoFatturazioneComponent implements OnInit {

  @Input() datiAnaForm!: FormGroup;

  setRequired = setRequired;
  fatturaUnica = false;

  ibanMinLength!: number | null;
  ibanMaxLength!: number | null;

  datiFattForm!: FormGroup;

  constructor(public dataService: DataService, private fb: FormBuilder) {

    this.datiFattForm = this.fb.group({
      modalitaSpedizione: new FormControl('0', [Validators.required]),
      accorpaFatture: new FormControl('1', [Validators.required]),

      mails: new FormArray([
        new FormControl('', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")])
      ]),

      tipoIndirizzoCart: new FormControl('0'),

      sdi: new FormControl(''),
      pec: new FormControl('', [Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")]),

      titolareConto: new FormGroup({
        nome: new FormControl(''),
        cognome: new FormControl(''),
        codiceFiscale: new FormControl(''),
        piva: new FormControl(''),
        ragioneSociale: new FormControl('')
      }),

      // banca: new FormControl(),
      iban: new FormControl(''),

      sottoscrittore: new FormGroup({
        nome: new FormControl(''),
        cognome: new FormControl(''),
        codiceFiscale: new FormControl(''),
      }),

      modalitaPagamento: new FormControl(),
      indirizzo: new FormGroup({
        toponimo: new FormControl(''),
        indirizzo: new FormControl(''),
        civico: new FormControl(''),
        comune: new FormControl(''),
        cap: new FormControl(''),
        provincia: new FormControl(''),
        // presso: new FormControl(''),
      }),
    })

    console.log('iban control:', this.datiFattForm.get('iban'));
    console.log('iban control value:', this.datiFattForm.get('iban')?.value);
    console.log('iban control status:', this.datiFattForm.get('iban')?.status);
    console.log('iban control enabled:', this.datiFattForm.get('iban')?.enabled);

  }

  ngOnInit(): void {

    this.dataService._isCfStraniero$.subscribe(res => {
      this.datiFattForm.get('iban')?.clearValidators();
      this.setIbanValidators();
      this.datiFattForm.get('iban')?.updateValueAndValidity({ emitEvent: false });
    })

    // this.datiFattForm.valueChanges.subscribe(_ => {
    //   debugForm(this.datiFattForm.controls);
    // })

    if (this.dataService.prodotto?.tipo_utenza == 'BUS') {
      this.datiAnaForm?.get('tipoCliente')?.valueChanges.subscribe(tipo => {
        if (tipo == '0') {
          this.datiFattForm.get('sdi')!.addValidators([Validators.required, Validators.pattern(/^[A-Z0-9]{7}$/)]);
          this.datiFattForm.get('pec')!.addValidators(Validators.required);
        } else {
          this.datiFattForm.get('sdi')!.clearValidators();
          this.datiFattForm.get('pec')!.clearValidators();
        }
        this.datiFattForm.get('sdi')!.updateValueAndValidity();
        this.datiFattForm.get('pec')!.updateValueAndValidity();
      });

      this.datiFattForm.get('sdi')?.valueChanges.subscribe(val => {
        if (val) {
          // this.datiFattForm.get('pec')?.disable({ emitEvent: false });
          this.datiFattForm.get('pec')?.clearValidators();
        } else {
          this.datiFattForm.get('pec')!.addValidators([Validators.required, Validators.email]);
          // this.datiFattForm.get('pec')!.enable({ emitEvent: false });
        }
      })

      this.datiFattForm.get('pec')?.valueChanges.subscribe(val => {
        if (val) {
          // this.datiFattForm.get('sdi')?.disable({ emitEvent: false });
          this.datiFattForm.get('sdi')?.clearValidators();
        } else {
          this.datiFattForm.get('sdi')!.addValidators([Validators.required, Validators.pattern(/^[A-Z0-9]{7}$/)]);
          // this.datiFattForm.get('sdi')!.enable({ emitEvent: false });
        }
      })

      this.datiAnaForm.get('aziendaCondominio')?.valueChanges.subscribe(value => {
        if (value.formaGiuridica) {
          // if(value.formaGiuridica == 'DIND'){
          //   this.datiFattForm.get('titolareConto')?.get('codiceFiscale')?.setValue(value.codiceFiscale, { emitEvent: false });
          // }
          this.datiFattForm.get('titolareConto')?.get('piva')?.patchValue(value.piva);
          this.datiFattForm.get('titolareConto')?.get('ragioneSociale')?.patchValue(value.ragioneSociale);
        }
      })

      this.datiAnaForm.get('rappLegale')?.valueChanges.subscribe(value => {
        this.datiFattForm.get('sottoscrittore')?.get('nome')?.patchValue(value.nome, { emitEvent: false });
        this.datiFattForm.get('sottoscrittore')?.get('cognome')?.patchValue(value.cognome, { emitEvent: false });
      })

    } else {
      this.datiAnaForm.get('cliente')?.valueChanges.subscribe(cliente => {
        // console.log(cliente);
        this.datiFattForm.get('titolareConto')?.get('nome')?.patchValue(cliente.nome, { emitEvent: false });
        this.datiFattForm.get('titolareConto')?.get('cognome')?.patchValue(cliente.cognome, { emitEvent: false });
        this.datiFattForm.get('sottoscrittore')?.get('nome')?.patchValue(cliente.nome, { emitEvent: false });
        this.datiFattForm.get('sottoscrittore')?.get('cognome')?.patchValue(cliente.cognome, { emitEvent: false });
        // il codice fiscale non si aggiorna per event emit false in dati anagrafici
        // this.datiFattForm.get('titolareConto')?.get('codiceFiscale')?.patchValue(cliente.codiceFiscale, { emitEvent: false });
      })
      // this.datiFattForm.get('titolareConto')?.valueChanges.subscribe(res => {
      //   this.datiFattForm.get('titolareConto')?.get('codiceFiscale')?.patchValue(res.codiceFiscale, { emitEvent: false })
      //   this.datiFattForm.get('sottoscrittore')?.get('codiceFiscale')?.patchValue(res.codiceFiscale, { emitEvent: false })
      // })
    }

    // per debug
    // this.datiFattForm.valueChanges.subscribe(_ => {
    //   for (const control in this.datiFattForm.controls) {
    //     if (this.datiFattForm.controls[control].invalid) {
    //       // console.log(control, this.datiFattForm.controls[control].errors)
    //       // console.log(control, this.datiFattForm.get(control)?.errors)
    //       if (this.datiFattForm.get(control) instanceof FormGroup) {
    //         for (let subcontrol in (this.datiFattForm.get(control) as FormGroup).controls) {
    //           // console.log(control, subcontrol, (this.datiFattForm.get(control) as FormGroup).controls[subcontrol].errors);
    //         }
    //       }
    //     }
    //   }
    // })

    // this.datiFattForm.valueChanges.subscribe(_ => {
    //   console.log(_);
    //   for (const control in this.datiFattForm.controls) {
    //     if (this.datiFattForm.controls[control] instanceof FormGroup) {
    //       for (const subcontrol in (this.datiFattForm.controls[control] as FormGroup)?.controls) {
    //         if ((this.datiFattForm.controls[control] as FormGroup).controls[subcontrol]?.invalid) {
    //           console.log(control, subcontrol, (this.datiFattForm.controls[control] as FormGroup).controls[subcontrol].errors)
    //         }
    //       }
    //     } else {
    //       if (this.datiFattForm.controls[control].invalid) {
    //         console.log(control, this.datiFattForm.controls[control].errors)
    //       }
    //     }
    //   }
    // })


    this.datiFattForm.get('modalitaSpedizione')?.valueChanges.subscribe(value => {
      if (value == '0') {
        for (let control in (this.datiFattForm.get('mails') as FormArray).controls) {
          (this.datiFattForm.get('mails') as FormArray).controls[control].setValidators(Validators.required);
          (this.datiFattForm.get('mails') as FormArray).controls[control].updateValueAndValidity({ emitEvent: false });
        }
        for (let control in (this.datiFattForm.get('indirizzo') as FormGroup).controls) {
          (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].clearValidators();
          (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
        }
      } else {
        for (let control in (this.datiFattForm.get('mails') as FormArray).controls) {
          (this.datiFattForm.get('mails') as FormArray).controls[control].clearValidators();
          (this.datiFattForm.get('mails') as FormArray).controls[control].updateValueAndValidity({ emitEvent: false });
        }

        this.datiFattForm.get('tipoIndirizzoCart')?.valueChanges.subscribe(value => {
          if (value == '2') {
            for (let control in (this.datiFattForm.get('indirizzo') as FormGroup).controls) {
              // if (control == 'indirizzo') {
              //   (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].addValidators(Validators.pattern(/^[a-zA-Z\s]+$/));
              // }
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].addValidators(Validators.required);
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
            }
            this.fatturaUnica = false;
          }
          else if (value == '1') {
            this.fatturaUnica = true;
            this.datiFattForm.get('accorpaFatture')?.patchValue('1');
            for (let control in (this.datiFattForm.get('indirizzo') as FormGroup).controls) {
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].clearValidators();
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
            }
          }
          else {
            for (let control in (this.datiFattForm.get('indirizzo') as FormGroup).controls) {
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].clearValidators();
              (this.datiFattForm.get('indirizzo') as FormGroup).controls[control].updateValueAndValidity({ emitEvent: false });
            }
            this.fatturaUnica = false;
          }
        })
      }
    })

    this.datiFattForm.get('modalitaPagamento')?.valueChanges.subscribe(value => {
      if (value == '0') {
        for (let control in this.titolareConto.controls) {

          if (control == 'codiceFiscale') {
            this.titolareConto.controls[control].addValidators(Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i));
          }
          if (this.dataService.prodotto?.tipo_utenza == 'DOM' && control == 'ragioneSociale' || control == 'piva') {
            // pass
          } else {
            this.titolareConto.controls[control].addValidators(Validators.required);
          }
          this.titolareConto.controls[control].updateValueAndValidity({ emitEvent: false });
        }
        for (let control in this.sottoscrittore.controls) {
          this.sottoscrittore.controls[control].addValidators(Validators.required);
          if (control == 'codiceFiscale') {
            this.sottoscrittore.controls[control].addValidators(Validators.pattern(/^[A-Z]{6}\d{2}[A-Z]\d{2}[A-Z]\d{3}[A-Z]$/i));
          }
          this.sottoscrittore.controls[control].updateValueAndValidity({ emitEvent: false });
        }
        // if (this.datiAnaForm?.get('tipoCliente')?.value == '0') {
        // this.datiFattForm.get('iban')?.addValidators([Validators.required, Validators.pattern(/^[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/)]);
        this.setIbanValidators();
        this.datiFattForm.get('iban')?.updateValueAndValidity({ emitEvent: false });
        // }
      } else {
        for (let control in this.titolareConto.controls) {
          this.titolareConto.controls[control].clearValidators();
          this.titolareConto.controls[control].updateValueAndValidity({ emitEvent: false });
        }
        for (let control in this.sottoscrittore.controls) {
          this.sottoscrittore.controls[control].clearValidators();
          this.sottoscrittore.controls[control].updateValueAndValidity({ emitEvent: false });
        }
        this.datiFattForm.get('iban')?.clearValidators();
        this.datiFattForm.get('iban')?.updateValueAndValidity({ emitEvent: false });
      }
    })

    this.titolareConto?.valueChanges.subscribe(value => {
      if (value.nome || value.cognome) {
        this.titolareConto.get('nome')?.enable({ emitEvent: false });
        this.titolareConto.get('cognome')?.enable({ emitEvent: false });
        this.titolareConto.get('codiceFiscale')?.enable({ emitEvent: false });
        this.titolareConto.get('ragioneSociale')?.disable({ emitEvent: false });
        this.titolareConto.get('piva')?.disable({ emitEvent: false });
        this.titolareConto.get('ragioneSociale')?.setValue('', { emitEvent: false });
        this.titolareConto.get('piva')?.setValue('', { emitEvent: false });
      } else if (value.ragioneSociale) {
        this.titolareConto.get('nome')?.disable({ emitEvent: false });
        this.titolareConto.get('cognome')?.disable({ emitEvent: false });
        this.titolareConto.get('codiceFiscale')?.disable({ emitEvent: false });
        this.titolareConto.get('ragioneSociale')?.enable({ emitEvent: false });
        this.titolareConto.get('piva')?.enable({ emitEvent: false });
        this.titolareConto.get('nome')?.setValue('', { emitEvent: false });
        this.titolareConto.get('cognome')?.setValue('', { emitEvent: false });
      } else {
        this.titolareConto.get('nome')?.enable({ emitEvent: false });
        this.titolareConto.get('cognome')?.enable({ emitEvent: false });
        this.titolareConto.get('ragioneSociale')?.enable({ emitEvent: false });
        this.titolareConto.get('codiceFiscale')?.enable({ emitEvent: false });
        this.titolareConto.get('piva')?.enable({ emitEvent: false });
        // this.titolareConto.get('nome')?.setValue('', { emitEvent: false });
        // this.titolareConto.get('cognome')?.setValue('', { emitEvent: false });
        // this.titolareConto.get('ragioneSociale')?.setValue('', { emitEvent: false });
        // this.titolareConto.get('codiceFiscale')?.setValue('', { emitEvent: false });
        // this.titolareConto.get('piva')?.setValue('', { emitEvent: false });

      }
      // console.log(this.titolareConto.errors);
    })
    this.datiFattForm.get('modalitaPagamento')?.patchValue('0', { emitEvent: true });

    if (this.dataService.ctr_data) {
      setTimeout(() => {
        this.datiFattForm.patchValue(this.dataService.ctr_data.datiPagamento);
      }, 2000);
    }

  }

  get mails() {
    return this.datiFattForm.get('mails') as FormArray;
  }

  get indirizzoForm() {
    return this.datiFattForm.get('indirizzo') as FormGroup;
  }

  get sottoscrittore() {
    return this.datiFattForm.get('sottoscrittore') as FormGroup;
  }

  get titolareConto() {
    return this.datiFattForm.get('titolareConto') as FormGroup;
  }

  get numeroPunti() {
    if (
      (this.dataService.datiFornitura?.get('richieste') as FormArray).length > 1
      || ((this.dataService.datiFornitura?.get('richieste') as FormArray).at(0).get('pods') as FormArray).length > 1
      || ((this.dataService.datiFornitura?.get('richieste') as FormArray).at(0).get('pdrs') as FormArray).length > 1
    ) {
      return true;
    }
    return false;
  }

  setIbanValidators() {
    if (this.datiFattForm.get('modalitaPagamento')?.value == '0' && this.dataService.isCfStraniero$.value) {
      this.datiFattForm.get('iban')?.setValidators([Validators.required, Validators.minLength(15), Validators.maxLength(32)]);
      this.ibanMinLength = 15;
      this.ibanMaxLength = 32;
    } else {
      this.datiFattForm.get('iban')?.setValidators([Validators.required, Validators.pattern(/^(it|IT)[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/)]);
      this.ibanMinLength = null;
      this.ibanMaxLength = null;
    }

  }


  addMail() {
    (this.datiFattForm.get('mails') as FormArray).push(
      new FormControl('', [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")])
    );
  }

  removeMail(id: number) {
    (this.datiFattForm.get('mails') as FormArray).removeAt(id);
  }

}
